import { updateOneCacheItem } from 'app/core/cache/helpers';
import { Certificate, Params, WebsocketMessage } from 'app/types';

import { useQueryClient } from '@tanstack/react-query';

import { getQueryKeyByModel } from '../updates-listener/helpers';

export interface FileGeneratedProps {
  message: WebsocketMessage;
  type: 'pdf' | 'csv';
}

/**
 * For PDF or CSV files generated event
 * @param props
 * @returns
 */
export default function FileGenerated(props: FileGeneratedProps) {
  const { message, type } = props;

  const queryClient = useQueryClient();

  const queryKey = getQueryKeyByModel(message.model);

  let data: Params = { fileUrl: message?.model.fileUrl };
  if (type === 'pdf') {
    data = { document: { fileUrl: message.model.fileUrl } };
  }
  updateOneCacheItem<Certificate>(queryClient, queryKey, data);

  return null;
}
